import { encryptStorage } from '@/utils/storage';

const loadPersistedBusinessLine = () => {
  try {
    return encryptStorage.getItem('selectedBusinessLine') || null;
  } catch (e) {
    return null;
  }
};

export default () => ({
  selectedBusinessLine: loadPersistedBusinessLine(),
  companies: {},
  interactions: {},
  // Slot propio de la vista "Sin gestionar". Separado de `interactions` para que
  // las dos vistas no se pisen la tabla al navegar entre ellas.
  noManagementInteractions: {},
  persons: {},
  leads: {},
  prospectos: {},
  business: {},
  sales: {},
  origins: {},
  campaigns: {},
  businessLines: {},
  businessLinesDirty: false,
  businessLineStatuses: {},
  variables: {},
  varTypes: {},
  phases: {},
  discardReason: {},
  currencies: {},
  interactionState: {},
  statusInteraction: {},
  phaseInteraction: {},
  stageInteraction: {},
  phasesAll: {},
  stagesAll: {},
  // Catálogo de tipificación para la barra de progreso de las tarjetas del
  // tablero. Slots propios a propósito: `phasesAll`/`stagesAll` los recarga el
  // popup de Filtros del listado sin filtrar por línea de negocio, y compartirlos
  // haría que una vista pisara el catálogo de la otra.
  kanbanPhases: {},
  kanbanStages: {},
  statusForPhaseFilter: {},
  statusForStageFilter: {},
  phaseForStageFilter: {},
  users_pbx: {},
  entities: {},
  needs: {},
  businessByPhase: {},
  itxByStatus: {},
  itxByPhase: {},
  itxByStage: {},
  crmContentTypes: {},
  fqIntegration: {},
  variablesStatus: {},
  phase: {},
  phaseStage: {},
  status: {},
  stage: {},
  contact: {},
  statusList: {},
  zoneFilter: null,
  zones: {},
  // Motivos de negocio perdido (Configuraciones generales, `LostReason/`).
  lostReasons: {},
  lostReasonFilter: null,
  // Sector económico (Configuraciones generales, `EconomicSector/`).
  sectors: {},
  sectorFilter: null,
  // El catálogo completo para el selector de la empresa (FormCompany). Aparte
  // de `sectors`, que es la tabla del tab y viene paginada de 10 en 10.
  sectorOptions: {},
  usersAdmin: {},
  reports: {},
  reportsTypes: {},
  reportsFilter: null,
  isReportForm: false,
  coordinadores: [],

  contactFilter: null,
  stageFilter: {},
  phaseFilter: {},
  phaseStageFilter: {},
  phaseFilteredForPriority: null,
  phaseFilterPriority: null,
  statusFilteredForPriority: null,
  statusFilterPriority: null,
  statusFilter: null,
  stageFilteredForPriority: null,
  stageFilterPriority: null,
  prospectoFilter: null,
  discardReasonFilter: null,
  currencyFilter: null,
  multipleUserFilter: null,
  companyFilter: null,
  fqIntegrationFilter: null,
  interactionFilter: null,
  // Filtro de la vista "Sin gestionar": lleva fijo `no_management=true` más la
  // paginación. Propio, por lo mismo que `noManagementInteractions`.
  noManagementFilter: null,
  personFilter: null,
  leadFilter: null,
  businessFilter: null,
  saleFilter: null,
  originFilter: null,
  usersFilter: null,
  needFilter: null,
  campaignFilter: null,
  businessLineFilter: null,
  variablesFilter: null,
  varTypesFilter: null,
  phasesFilter: null,
  interactionStateFilter: null,
  rules: {},
  rulesFilter: null,
  formulas: {},
  formulasFilter: null,

  companyFilterSelect: null,
  interactionFilterSelect: null,
  personFilterSelect: null,
  businessFilterSelect: null,
  saleFilterSelect: null,
  originFilterSelect: null,
  campaignFilterSelect: null,
  businessLineFilterSelect: null,
  variableFilterSelect: null,
  interactionStateSelect: null,

  currentInteraction: null,
  // Acciones habilitadas en la etapa actual de la gestión abierta, con su
  // contador. Lo siembra el detalle con lo que ya trae `stage_actions` y lo
  // refresca `fetchStageActions` tras ejecutar una. Es un slot compartido para
  // que la cabecera del drawer y el panel del detalle miren el mismo número.
  stageActions: { itxId: null, crm_stage: null, actions: [] },
  interactionCalls: { itxId: null, loaded: false, loading: false, results: [] },
  currentPerson: null,
  currentBusiness: null,
  currentComment: null,
  currentCompany: null,
  comment: null,
  discards: {},
  transactions: {},
  transactionsFilter: null,
  requestCrmConfig: null,
  senders: null,
  generalDateInit: null,
  generalDateEnd: null,
  tabInteractionActive: "1",
  optionesRetoma: {},
  optionesRetomaFilter: null,

  tipificaciones: {},
  tipificacionesFilter: null,

  emailAccounts: {},
  emailAccountsFilter: null,

  // Campana del CRM (FC-743, `.claude/crm_notificaciones/`). Los tres grupos
  // que pintan las pestañas, tal como los devuelve `helpers/bellApi.js`.
  //
  // Un solo sitio para los dos paneles: NavBar (escritorio) y MobileHeader
  // montan el MISMO `BellPanelBody`, así que si cada uno pidiera lo suyo
  // tendríamos dos verdades y el doble de peticiones. El badge también sale de
  // aquí.
  bell: {
    toDo: { items: [], total: 0, urgent: 0 },
    news: { items: [], total: 0, urgent: 0 },
    followUp: {
      stalled: { items: [], total: 0 },
      overdue_tasks: { items: [], total: 0 },
    },
    // Por grupo, para que una pestaña en blanco no muestre el esqueleto de otra.
    cargando: { toDo: false, news: false, followUp: false },
    // `null` = nunca se ha consultado. Lo usan los estados vacíos para no decir
    // "Nada pendiente" antes de la primera respuesta.
    consultado: { toDo: null, news: null, followUp: null },
  },


  // Alertas de asignación (épica `.claude/alertas_crm/`). Ya en la forma de la
  // vista (`helpers/assignmentAlertsApi.js`): `recibidas` alimenta la campana y
  // los resaltados; `enviadas`, el seguimiento del remitente (task_4).
  assignmentAlerts: {
    recibidas: [],
    enviadas: [],
    cargadas: false,
    cargando: false,
    // Interacciones sin ver según el SERVIDOR (`summary/`, socket y
    // `mark_seen/`). La lista viene paginada y contarla se quedaría corto.
    // `null` = todavía no llegó del servidor: el getter cuenta la lista.
    unseenCount: null,
    // Tarjetas/filas cuyo aviso ya se marcó visto en esta sesión: `id de
    // gestión → true`. Las filas traen `assignment_alert` hasta que se
    // recargan; esto lo apaga al momento. Se llena al marcar desde la tarjeta
    // o con los `managements` que devuelve `mark_seen/`.
    filasVistas: {},
  },
  // La última llegada EN VIVO (socket o simulador). Las vistas abiertas la
  // vigilan con un watch sobre `seq` para traer la fila nueva sin recargar.
  assignmentArrival: { seq: 0, ids: [], tipo: null, alertaId: null },
  // Avisos emergentes de asignación (task_4): los pinta `AssignmentToasts`.
  // { id, tipo: "recibida" | "enviada", titulo, texto, accion?: { label, ruta } }
  assignmentToasts: [],

  // Solicitudes de aprobación pendientes del alcance del rol, para el contador
  // de «Aprobaciones» en el menú lateral. null = no aplica (gestor) o sin cargar.
  // Lo llena la acción `refreshApprovalsCount`.
  approvalsPendingCount: null,
  // Última solicitud de aprobación resuelta que le llegó a este usuario (task_3
  // CA-01). El detalle abierto vigila `seq` y, si es su interacción, recarga su
  // estado sin esperar a que se vuelva a abrir.
  approvalResolution: { seq: 0, managementId: null },
  // Último cambio EN VIVO en la cola de quien resuelve (socket
  // `crm_approval_pending`): `action` como la manda el backend («created»…) y
  // la solicitud en forma de vista. `FxApprovals` vigila `seq` para actualizar
  // sus listas sin recargar.
  approvalQueueChange: { seq: 0, action: null, solicitud: null },
  // Pedido de abrir el panel lateral de detalle desde cualquier pantalla (hoy:
  // el aviso «Ver la interacción» de Aprobaciones). Lo atiende el panel común
  // que monta FxCrmLayout, vigilando `seq`.
  // `tab` es opcional: la clave de la pestaña del detalle en la que abrir
  // (`llamadas`, `agenda`, `correos`…). Sin ella el panel abre en la suya.
  detailDrawerRequest: { seq: 0, id: null, tab: null },

  company_crm_max_digits: null,

  // FEXIA CRM chat — integración real con backend (streaming por WebSocket).
  // messages: [{ id, role, content, timestamp, format, file, streaming? }]
  crmChat: {
    chatId: null,
    messages: [],
    isStreaming: false,
    // Badge de notificaciones: cuenta respuestas de la IA generadas con el
    // panel cerrado. Se limpia al abrir el chat.
    isPanelOpen: false,
    unreadCount: 0,
  },

  // FEXIA — sugerencias reales (config admin). GET /api/fxCrm/Suggestions/
  // devuelve un array plano de { id, nombre, rol, activa, ... }; se envuelve
  // en {data:{results}} para reusar addEnty/updateState/removeState.
  crmSuggestions: {
    data: {
      results: [],
    },
  },
});
